
import Vue from "vue";
import AppGroup from "@/components/cashier/CashierGroup.vue";
import { ProductGroup } from "@/models/base/product-group";
import { ProductGroupService } from "@/services/product-group-service";
import AppCustomGroupEdit from "@/components/cashier/CashierCustomGroupEdit.vue";
import { CashierButtonConfig, ICustomGroup } from "@/models/dossier-configs/cashier";

function isLightColor(color:string):boolean {
	let hex = color.trim().replace("#", "");
	if (hex.length == 3 || hex.length == 4) {
		hex = hex.split("").map(c => c + c).join("");
	}
	if (hex.length < 6) return true;
	let r = parseInt(hex.substring(0, 2), 16);
	let g = parseInt(hex.substring(2, 4), 16);
	let b = parseInt(hex.substring(4, 6), 16);
	if (isNaN(r) || isNaN(g) || isNaN(b)) return true;
	return (0.299 * r + 0.587 * g + 0.114 * b) > 150;
}

export default Vue.extend({
	data() {
		return {
			topLevelGroups: [] as ProductGroup[],
			activeGroupID: 0,
			activeParentID: 0,
			openGroupModal: false,
			editGroup: null as null | ICustomGroup,
			editIsNew: false
		};
	},
	props: {
		config: {
			type: Object as () => CashierButtonConfig | null,
			default: null
		}
	},
	computed: {
		customGroups():ICustomGroup[] {
			return this.config ? this.config.getSortedCustomGroups() : [];
		},
		showCustomGroups():boolean {
			return this.activeGroupID <= 0 || this.filteredGroups.length == this.topLevelGroups.filter(c => c.ShowOnDisplay).length;
		},
		filteredGroups():ProductGroup[]{
			if(this.activeGroupID>0){
				let a = this.topLevelGroups.find(c => c.ID == this.activeGroupID && c.ShowOnDisplay) as ProductGroup;
				if(a && a.Children.length > 0){
					return [a,...a.Children];
				}
				let b = this.topLevelGroups.find(c => c.ID == this.activeParentID && c.ShowOnDisplay ) as ProductGroup;
				if(b && b.Children.length > 0){
					return [b,...b.Children];
				}

			}
			return this.topLevelGroups.filter(c => c.ShowOnDisplay);
		}
	},
	watch: {
		activeGroupID(){
			this.$emit("update-group",this.activeGroupID);
		}
	},
	methods: {
		activate(group: ProductGroup) {
			this.activeGroupID = group.ID;
			this.activeParentID = group.ParentGroup ? group.ParentGroup.ID : 0;
		},
		customGroupStyle(group: ICustomGroup) {
			if (!group.Color) return {};
			return {backgroundColor: group.Color, color: isLightColor(group.Color) ? "var(--main-gray-6)" : "#fff"};
		},
		activateCustom(group: ICustomGroup) {
			this.activeGroupID = group.ID;
			this.activeParentID = 0;
		},
		addCustomGroup() {
			if (!this.config) return;
			this.editGroup = {ID: this.config.nextCustomGroupID(), Name: "", Color: "", DisplayOrder: this.config.CustomGroups.length};
			this.editIsNew = true;
			this.openGroupModal = true;
		},
		editCustomGroup(group: ICustomGroup) {
			this.editGroup = {...group};
			this.editIsNew = false;
			this.openGroupModal = true;
		},
		saveCustomGroup(group: ICustomGroup) {
			if (!this.config) return;
			let i = this.config.CustomGroups.findIndex(g => g.ID == group.ID);
			if (i == -1) {
				this.config.CustomGroups.push(group);
			} else {
				this.$set(this.config.CustomGroups, i, group);
			}
			this.openGroupModal = false;
			this.$emit("save-config", this.config);
		},
		async deleteCustomGroup() {
			if (!this.config || !this.editGroup) return;
			let t = (key:string) => this.$t(key).toString();
			let ok = await this.$wf.confirm(t("components.sales.Cashier.delete-group-confirm"), t("common.yes"), t("common.no"), t("common.warning"), "warning");
			if (!ok) return;
			this.config.removeCustomGroup(this.editGroup.ID);
			if (this.activeGroupID == this.editGroup.ID) {
				this.activeGroupID = 0;
			}
			this.openGroupModal = false;
			this.$emit("save-config", this.config);
		},
		goHome() {
			this.$router.push("/home");
		}
	},
	async created() {
		let groups = await ProductGroupService.getAllGroups();
		this.topLevelGroups = groups.map(g => g.copy());
	},
	components: {
		AppGroup,
		AppCustomGroupEdit
	}
});
